import React from 'react';
import type { FC } from 'react';

interface LogoutIconProps {
    className?: string;
}

export const LogoutIcon: FC<LogoutIconProps> = ({ className }) => {
    return (
        <svg
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>Logout Icon</title>
            <path
                d="M6 15H2.66667C2.22464 15 1.80072 14.8361 1.48816 14.5444C1.17559 14.2527 1 13.857 1 13.4444V2.55556C1 2.143 1.17559 1.74733 1.48816 1.45561C1.80072 1.16389 2.22464 1 2.66667 1H6"
                stroke="#FF6577"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path
                d="M10.543 12.4436L14.9874 7.99913L10.543 3.55469"
                stroke="#FF6577"
                strokeLinecap="square"
                strokeLinejoin="round"
            />
            <path d="M14.3398 8H6.33984" stroke="#FF6577" strokeLinecap="square" strokeLinejoin="round" />
        </svg>
    );
};
